import { useEffect, useRef, useState } from "react";


export default function ProctorCamera({ onCheating }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const intervalRef = useRef(null);
  const [lastResult, setLastResult] = useState(null);
  const PROCTOR_API = process.env.REACT_APP_PROCTOR_API_URL;

  // -------------------------------
  // START CAMERA SAFELY
  // -------------------------------
  useEffect(() => {
    let cancelled = false;

    const startCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "user" }
        });

        if (cancelled) return;

        streamRef.current = stream;

        if (videoRef.current) {
          videoRef.current.srcObject = stream;

          // 🔐 ensure video is actually ready
          await videoRef.current.play();
        }
      } catch (err) {
        console.error("❌ Camera access error:", err);
      }
    };

    startCamera();

    return () => {
      cancelled = true;

      // 🧹 STOP CAMERA ON UNMOUNT
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((t) => t.stop());
      }
    };
  }, []);

  // -------------------------------
  // FRAME CAPTURE + API CALL
  // -------------------------------
  useEffect(() => {
    intervalRef.current = setInterval(async () => {
      const video = videoRef.current;
      const canvas = canvasRef.current;

      // 🚨 defensive guards
      if (!video || !canvas) return;
      if (video.readyState < 2) return; // video not ready

      const ctx = canvas.getContext("2d");

      canvas.width = 320;
      canvas.height = 240;

      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
// -------------------------------
// VISUAL FEEDBACK (GREEN / RED)
// -------------------------------
if (lastResult) {
  ctx.lineWidth = 3;

  // 🟢 Green = OK, 🔴 Red = Issue
  ctx.strokeStyle =
    lastResult.faces === 1 && lastResult.status === "clean"
      ? "green"
      : "red";

  // Simple full-frame box (abhi)
  ctx.strokeRect(5, 5, canvas.width - 10, canvas.height - 10);
}

      const image = canvas.toDataURL("image/jpeg");

      try {
        const res = await fetch(`${PROCTOR_API}/analyze`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ image }),
        });

        if (!res.ok) return;

        const data = await res.json();
setLastResult(data);



        // 🔴 only react to real cheating
        if (data && data.status && data.status !== "clean") {
          onCheating(data);
        }
      } catch (err) {
        console.warn("⚠️ Proctor API error:", err);
      }
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [onCheating]);

  return (
    <>
      {/* hidden video feed */}
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        className="fixed bottom-4 right-4 w-48 h-36 rounded-lg border-4 z-50"
      />

      {/* hidden canvas */}
      <canvas
        ref={canvasRef}
        width={320}
        height={240}
        className="fixed bottom-4 right-4 w-48 h-36 rounded-lg border-4 z-50"
      />
    </>
  );
}
